import React, {useState} from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dummyImg from "../../assets/images/user.png";
import CloseIcon from '@mui/icons-material/Close';

function FloatingWindow ({appInfo, fMessages,closeFloat, setCloseFloat,setOpenBot, setLangSwitcher,isLang, botInfo,langSwitcher,openBot}) {
    const [cardFDetails, setFCardDetails]= useState({
        isFloating: appInfo?.fCardDetails ? appInfo?.fCardDetails?.isFloating : "false",
        title: appInfo?.fCardDetails ?  appInfo?.fCardDetails?.title :  "Title",
        img: appInfo?.fCardDetails ? appInfo?.fCardDetails?.img :dummyImg,
    })

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true
    };
    

    // if(botInfo?.fCardDetails !== undefined){
    //     setFCardDetails(botInfo?.fCardDetails)
    //     setFMessages(botInfo?.fCardMessages)
    // }
    
    const openLangSwitcher =()=> {
        if(botInfo?.data?.bot?.language.length > 1 && isLang === false){
            setLangSwitcher(!langSwitcher); 
            setCloseFloat(true);
        }else{
            setOpenBot(true); 
            setCloseFloat(true);
        } 
    }
    
    return (
        cardFDetails.isFloating === "true" ?
            <>
                <div className={`floating-card ${closeFloat || openBot ? "hide-float" : ""}`} >
                    {/* <CloseIcon className="close-float" onClick={()=> openLangSwitcher()}/> */}
                    <div onClick={()=> openLangSwitcher() }>
                        {
                            fMessages?.length > 0 &&
                            <div>
                                <Slider {...settings}>
                                    {
                                        fMessages?.map((msg, i)=>{
                                            return(
                                                msg.message &&
                                                <div className="slider-section">
                                                    <div className='silder-sec-header'>
                                                        <h3>{msg?.title}</h3>
                                                        {
                                                            cardFDetails?.img &&
                                                            <img className="card-img" src={cardFDetails?.img} onError={(e) => ( (e.target.src = dummyImg))} alt="bot logo"/>
                                                        }
                                                    </div>
                                                    <div className="slider-wrapper" key={i}>
                                                        {fMessages?.length > 1 && <div className='slider-count'><span className='slider-count-1'>{i+1}</span>/{fMessages?.length}</div>}
                                                        <p>{msg?.message}</p>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        }
                    </div>
                </div>
                <div className={`floating-nibs ${openBot ? "hide-float" : ""}`}>
                    {
                        fMessages?.length > 0 && <div className=''>{fMessages[0]?.title} {fMessages[0]?.message}</div>
                    }
                </div>
            </>
        :
            <></>
    )
}
export default FloatingWindow